<div class="container-expanded bg-hero hero-top hero-fh"
    (click)="ctaClick.emit()">
    <div class="container column align-items-start justify-content-center fh">
        <div class="col-12 col-lg-6 col-lg-offset-3 text-center">
            <h1 class="mat-headline-4 mb--16">{{ headline }}</h1>
            <ng-container *ngIf="orderComplete; else orderRejected">
                <h1 class="page-title-responsive "
                    [innerHTML]="'page.thankyou.title' | translate:{value: productPurchased}"></h1>
                <div class="h4"
                    [innerHTML]="'page.thankyou.subtitle' | translate"></div>
            </ng-container>
            <ng-template #orderRejected >
                <h1 class="page-title-responsive "
                [innerHTML]="'page.thankyou.title-rejected' | translate:{value: productPurchased}"></h1>
            <div class="h4"
                [innerHTML]="'page.thankyou.subtitle-rejected' | translate"></div>
            </ng-template>

            <ng-container *ngIf="cta">
                <div class="actions mt--48">
                    <div *ngIf="cta.text" class="cta-title"
                        [innerHTML]="cta.text"></div>
                    <!-- <button *ngIf="cta.action" 
                     mat-raised-button color="primary" (click)=ctaAction(button.value)>Continua la navigazione</button> -->
                    <button *ngIf="cta.action"
                        mat-raised-button color="primary"
                        (click)=ctaAction()>Continua la navigazione</button>
                </div>
            </ng-container>
        </div>
    </div>
</div>